/*
 * File: \src\service\data-rangers\src\config.js
 * Created Date: 2020-11-05 09:14:51
 * Author: gaozw
 * -----
 * Last Modified: 2021-08-02 2:14:16 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */
const serviceConfig={
    jsSrc:"https://mapnew5.midea.com/dataFinder-sdk/web-sdk.js",
    loadNumberMax:3
}

const initConfig = {
    app_id: 10000032,//  必须替换成申请的 app_id
    channel_domain: 'https://iotsdk.midea.com',  // 替换为私有部署部署服务地址
    log: false, // 开启调试日志
    disable_webid:true,
    disable_ssid:true,
    disable_sdk_monitor:true,
    auto_profile:false,
    disable_session: true  // 禁止心跳检测
}

const paramsConfig={
    evtParams: { // 设置共有的事件属性，具体见API
    },
    common_params: '', // 设置用户属性（公共属性）
    disable_auto_pv: true,
    user_unique_id:'meixin_service'
}

export default {initConfig,paramsConfig,serviceConfig}
